import { QueryClient } from '@tanstack/react-query'

/**
 * Единый QueryClient админки.
 *
 * - `staleTime: 0`: каждое монтирование / возврат фокуса даёт свежие
 *   данные. Критично при активном тестировании и при правках данных
 *   извне (мобильное приложение, Supabase Studio) — realtime-канал
 *   ловит только `orders`/`status_history`/`audit_log`, а
 *   `profiles`/`companies` без window-focus refetch «застывали» бы
 *   до следующего действия.
 * - `gcTime: 5 * 60_000`: держим кэш 5 минут после отмонтирования —
 *   чтобы `initialData` и prefetch on hover сохраняли эффект
 *   «мгновенного» возврата в список, даже когда само значение
 *   считается устаревшим и рефетчится фоном.
 * - `refetchOnWindowFocus: true`: возврат во вкладку обновляет всё.
 * - `refetchOnReconnect: 'always'`: после сети тоже обновляемся.
 * - `retry: 1`: не долбимся в упавший Supabase.
 *
 * Для отдельных запросов (тяжёлые справочники, дашборд) staleTime
 * настраивается точечно через опции `useQuery`.
 */
export function createAppQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 0,
        gcTime: 5 * 60_000,
        refetchOnWindowFocus: true,
        refetchOnReconnect: 'always',
        retry: 1,
      },
    },
  })
}
